import { FreeBetBettingRestrictions, FreeBetCondition, FreeBetPBSVoucherInfo } from "./free-bet.model";

export class C_FreeBetTicket {
  Conditions: FreeBetCondition[];
  BonusOfferId: number;
  VoucherCode: string;
  Amount: number;
  ExpirationDate: string;
  IsRedeemable: boolean;
  Name: string;
  IsTerminalVoucher: boolean;
  PBSVoucherInfo: FreeBetPBSVoucherInfo;
  HasFreeBet?: boolean;
  constructor(
    conditions: FreeBetCondition[],
    bonusOfferId: number,
    voucherCode: string,
    amount: number,
    expirationDate: string,
    isReddemable: boolean,
    name: string,
    isTerminalVoucher: boolean,
  ) {
    this.Amount = amount;
    this.BonusOfferId = bonusOfferId;
    this.Conditions = conditions;
    this.ExpirationDate = expirationDate;
    this.IsRedeemable = isReddemable;
    this.IsTerminalVoucher = isTerminalVoucher;
    this.Name = name;
    this.VoucherCode = voucherCode;
  }
}

export class C_FreeBetVoucher {
  Voucher: FreeBetBettingVoucher;

  static mapFBVoucher(voucherInfo): C_FreeBetVoucher {
    const freeBetVoucher = new C_FreeBetVoucher();
    freeBetVoucher.Voucher = new FreeBetBettingVoucher();
    freeBetVoucher.Voucher.BettingRestrictions = {
      RestrictionsByCutPoint: voucherInfo.BettingRestrictions.RestrictionsByCutPoint,
    };
    freeBetVoucher.Voucher.BonusOfferId = voucherInfo.BonusOfferId;
    freeBetVoucher.Voucher.CurrencyISOCode = voucherInfo.CurrencyISOCode;
    freeBetVoucher.Voucher.GeneralConditions = voucherInfo.GeneralConditions;
    freeBetVoucher.Voucher.VoucherAmountCt = voucherInfo.Amount;
    freeBetVoucher.Voucher.VoucherCode = voucherInfo.VoucherCode;
    return freeBetVoucher;
  }
}

export class FreeBetBettingVoucher {
  BettingRestrictions: FreeBetBettingRestrictions;
  BonusOfferId: number;
  CurrencyISOCode: string;
  GeneralConditions: unknown;
  VoucherAmountCt: number;
  VoucherCode: string;
}
